import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getOfflineCourseList
} from "../../api/service.js"
import {
  pUrl
} from "@/api/baseURL.js";

import {
  getUnderlineCourseListFromEnterprise
} from "@/apiCloud/offlineCourseList";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      tabSelect: "1",
      oneTpyeId: '',
      secondTypeId: '',
      offlineCoursesList: [],
      tabsList: [{
          title: "最热",
          value: 1
        },
        {
          title: "最新",
          value: 0
        }
      ],
      pageSize: 16,
      total: 0,
      pageNum: 1,
      aa: true,
      isJx: false,
    }
  },
  created() {
    this.getOfflineCourseList()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    //    var pUrl=window.location.href;
    //    // 是否是江西代理商访问
    //        if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //        console.log(1111,this.isJx)
    //        this.isJx=true;
    //    }
  },
  mounted() {
    var publicCourse = document.getElementById("offlineCourseList")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 + "px"
  },
  destory() {

  },

  methods: {
    // 课程列表
    getOfflineCourseList() {
      $('html,body').animate({
        scrollTop: '0px'
      }, 500)
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderby: this.tabSelect
      }
      getUnderlineCourseListFromEnterprise(data).then(res => {
        if (res.code==200) {
          this.offlineCoursesList = res.rows
          this.total = res.total
        }
      })
    },
    addTabsClass(index) {
      this.tabSelect = index
      this.pageNum = 1
      this.getOfflineCourseList()
    },
    currentChange(page) {
      this.pageNum = page
      this.getOfflineCourseList()
      // window.animate({scrollTop:0},500)
      // window.scrollTo(0,0)
    },
    GotoOfflineCourseDetail(courseId) {
      this.$router.push({
        path: "/offlineCourseDetail",
        query: {
          courseId
        }
      })
    },
  },

}



// WEBPACK FOOTER //
// ./src/pages/offlineCourseList/offlineCourseList.js